// bottom text to be shown on some screens
// contains login help and account creation link

// This file is the common bottom text for some screens

import * as React from "react";
import { Link } from "react-router-dom";
import "../../../assets/scss/Login/login/generic/loginFormBtmTxt.scss";
import EdButton from "./../../generic/edButton";

import { accRedircet } from "../../../services/genralServise";
import { config } from "../../../config/domain";

export interface ILoginFormBtmTxtProps {}

const LoginFormBtmTxt: React.FC<ILoginFormBtmTxtProps> = () => {
  return (
    <div className="login_frm_btm_txt">
      <p className="mg-b15">
        <Link to="/login/help" className="ed_button blue-link link_btn">
          Login Help?
        </Link>
      </p>
      <p>
        New User?{" "}
        <EdButton
          value="Create an account"
          btnTyp="blue-link"
          className="link_btn"
          onClick={() => accRedircet(config.openNewAcc)}
        />
      </p>
    </div>
  );
};

export default LoginFormBtmTxt;
